module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAJ0lEQVQ4jWNgGAWjYBQMHHjGwMDwkUr4DQMDQznNDR4Fo2AU0BMAAMLxJndM/MtFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sclose_icon@2x.png
// module id = qHtF
// module chunks = 28